export const iniciarChatWass = (numero, mensaje='Hola Antonia, deseo mas informacion de congenar') =>{
    let texto = encodeURI(mensaje)
    let link = `https://api.whatsapp.com/send?phone=57${numero}&text=${texto}`
    window.open(link)
}